// A copy of Harbor's region rule, in
// packages/integrations/harbor/shared/src/gcp-hosting.ts. Change both or
// neither.

// Words of lowercase letters joined by hyphens, then a number, as in
// `us-central1`. It keeps out a zone (`us-central1-a`) or an AWS region.
const GCP_REGION_PATTERN = /^[a-z]+(?:-[a-z]+)+\d+$/;

export const INVALID_GCP_REGION =
  "Enter the Google Cloud region the connector runs in, such as us-central1.";

/** Whether `region`, ignoring surrounding whitespace, has the shape of a
 * Google Cloud region's name. */
export const isGcpRegion = (region: unknown): region is string =>
  typeof region === "string" && GCP_REGION_PATTERN.test(region.trim());

// Google's rule for a project ID, and for a service account ID: 6 to 30
// characters, lowercase letters, digits and hyphens, starting with a letter
// and not ending with a hyphen. Harbor's `GCP_PROJECT_ID_PATTERN`, in
// packages/integrations/harbor/shared/src/vault.ts, has the same rule, and the
// connector takes it for a vault's project.
export const GCP_ID_PATTERN = /^[a-z][a-z0-9-]{4,28}[a-z0-9]$/;

/** Whether `projectId`, as it stands, is a Google Cloud project's ID. */
export const isGcpProjectId = (projectId: unknown): projectId is string =>
  typeof projectId === "string" && GCP_ID_PATTERN.test(projectId);
